export default __webpack_public_path__ + "static/media/login-bg.991be3ca.png";